import { render } from "./dropdown-menu.vue?vue&type=template&id=7474a39e&ts=true"
import script from "./dropdown-menu.vue?vue&type=script&lang=ts"
export * from "./dropdown-menu.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Repos\\Sinter\\SinterAdmin\\src\\sa-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__